const LOGOUT_KEY = "scratch-cg:logout";

export const broadcastLogout = (storage: Pick<Storage, "setItem"> = window.localStorage): void => {
    storage.setItem(LOGOUT_KEY, crypto.randomUUID());
};

export const subscribeToLogout = (
    onLogout: () => void,
    target: EventTarget = window,
): (() => void) => {
    const onStorage = (event: Event) => {
        if ((event as StorageEvent).key === LOGOUT_KEY) onLogout();
    };
    target.addEventListener("storage", onStorage);
    return () => target.removeEventListener("storage", onStorage);
};
